const removeEmptyValues = (values = {}) => {
  return Object.fromEntries(
    Object.entries(values).filter(([, value]) => {
      return value !== null && value !== undefined && value !== "" && !(Array.isArray(value) && !value.length);
    })
  );
};

export const getModalsIdsArray = (n = 5) => {
  return Array.from({ length: n }, (_, i) => (i === 0 ? "dynamic-modal" : "dynamic-modal" + i));
};

const getFileExtension = (file) => {
  if (typeof file === "string") {
    const parts = file.split(".");
    return parts.length > 1 ? parts.pop().toLowerCase() : "";
  }
  return "";
};

export const isFileImage = (file) => {
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
  const extension = getFileExtension(file);
  return imageExtensions.includes(extension.toLowerCase());
};

export const loadFileIcon = (file) => {
  if (isFileImage(file)) {
    return file;
  }

  const extension = getFileExtension(file);
  return `/assets/icons/${extension || "unknown"}.png`;
};

export const breakLongWord = (text, every = 10) =>
  (text ?? "").replace(new RegExp(`(.{${every}})`, "g"), "$1\u200B");

// moved from Services/Helpers/Actions.js \u2014 the pdf worker bundles this module,
// and Actions.js drags browser-only imports (localStorage, toastify, axios).
export const titleCase = (str) => {
  // Convert the string to lowercase and split it into an array of words
  let words = str?.toLowerCase().split(" ") || [];

  // Iterate through each word
  for (let i = 0; i < words.length; i++) {
    // Capitalize the first letter of the word and concatenate it with the rest of the word
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }

  // Join the words back into a single string
  let titleCaseStr = words.join(" ");

  return titleCaseStr;
};

export const humanText = (text) => (text && text?.length ? titleCase(text?.replaceAll(/[^a-zA-Z0-9]+/g, ' ')) : '')

export const getDefaultOption = (option, data = [], valueKey = 'value') => {
  return data?.find(opt => opt?.[valueKey] === option)
};
